// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationTwoToneSvg from "@ant-design/icons-svg/es/asn/NotificationTwoTone";
import AntdIcon from '../components/AntdIcon';

var NotificationTwoTone = function NotificationTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationTwoToneSvg
  }));
};

NotificationTwoTone.displayName = 'NotificationTwoTone';
export default React.forwardRef(NotificationTwoTone);